import { useAlert } from "../contexts/alertContext";

export default function AlertUI() {
    const STATUS = ["", "success", "error", "warning"];
    const COLOR = ["", "var(--green)", "var(--red-dark)", "var(--yellow-dark)"];
    const BACKGROUND = ["", "var(--green-light)", "var(--red-light)", "var(--yellow-light)"];
    const { alert } = useAlert();

    return (
        <section
            className="fixed right-3.5 p-5 z-[100] duration-200"
            style={{ bottom: alert.isShow ? "14px" : "-100%" }}
        >
            <div className="w-full rounded-xl p-4" style={{ background: BACKGROUND[alert.status] }}>
                <div
                    className="flex items-center font-bold text-yellow-900 uppercase"
                    style={{ color: COLOR[alert.status] }}
                >
                    {STATUS[alert.status]}
                </div>
                <div style={{ color: COLOR[alert.status] }}>{alert.message}</div>
            </div>
        </section>
    );
}
